<template>
  <div>
    <div v-if="running" class="mt-2">
      <v-progress-linear :value="percent" height="18" />
      <div v-if="busyLine" class="mt-1 orange--text text--darken-3">{{ busyLine }}</div>
      <div v-else-if="!loop" class="mt-1">{{ runningLine }}</div>
      <div class="mt-1">{{ progressLine }}</div>
    </div>
    <v-alert v-if="summary" :type="summary.type" dense outlined class="mt-2 mb-0">
      {{ summary.text }}
      <div v-if="summary.noKick" class="red--text text--darken-2">{{ summary.noKick }}</div>
      <v-expansion-panels v-if="list.length" accordion flat class="mt-1">
        <v-expansion-panel>
          <v-expansion-panel-header class="px-0">Rows ({{ list.length }})</v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <ul class="mb-0">
              <li v-for="r in list" :key="`kick-row-${r.avcId}`" :class="r.outcome === 'done' ? '' : toneClass(r.tone)">
                <strong>{{ r.avcId }}</strong> {{ r.message }}
              </li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-alert>
    <div v-if="note" class="mt-1 caption grey--text text--darken-2">{{ note }}</div>
  </div>
</template>

<script>
import {
  kickBusyText,
  kickProgressText,
  kickRows,
  kickRunSummary,
  kickRunningText,
} from "@/utils/cvcMigrationPage";

const TONE_CLASS = {
  green: "green--text text--darken-2",
  amber: "orange--text text--darken-3",
  red: "red--text text--darken-2",
  grey: "grey--text text--darken-2",
};

// The state of a kick run under the button that started it: the progress while it runs,
// then the summary with one line per service, and the note about the saved kick time.
// Section D (Kick all) and the rollback panel (Kick restored statics) share it; the page
// owns the run and hands its latest snapshot down.
export default {
  name: "KickRunView",
  props: {
    run: { type: Object, default: null },
    // This tab drives a loop for the run.
    loop: { type: Boolean, default: false },
    // Another run is being followed.
    busy: { type: Boolean, default: false },
    note: { type: String, default: "" },
    poiState: { type: String, default: "" },
  },
  computed: {
    running () {
      return !!this.run && this.run.status === "running";
    },
    percent () {
      const run = this.run;
      return run && run.toKick ? ((run.answered || 0) / run.toKick) * 100 : 0;
    },
    progressLine () {
      return this.run ? kickProgressText(this.run) : "";
    },
    runningLine () {
      return this.run ? kickRunningText(this.run, this.poiState) : "";
    },
    busyLine () {
      return this.busy && this.run ? kickBusyText(this.run, this.poiState) : "";
    },
    summary () {
      return this.run && this.run.status !== "running" ? kickRunSummary(this.run, this.poiState) : null;
    },
    list () {
      return this.run && this.run.status !== "running" ? kickRows(this.run) : [];
    },
  },
  methods: {
    toneClass (tone) {
      return TONE_CLASS[tone] || TONE_CLASS.grey;
    },
  },
};
</script>
